import { Address } from "@wingspanhq/wingspan-api-sdk";

/**
 * Flattens a v3 `Address` into a single comma-separated line for table cells,
 * summary rows and confirmation modals — e.g.
 * `555 Nevin St, Lvl 5, Brooklyn, New York, 11203`.
 *
 * `shared/selectors/selectorAddressString` is the v1 (`IAddress`) equivalent and
 * renders multi-line with the country name; this one is deliberately inline-only
 * and country-free, which is what the v3 screens display.
 */
export const selectorAddressLine = (
  address: Address | undefined
): string | undefined => {
  if (!address) {
    return undefined;
  }

  const line = [
    address.line1,
    address.line2,
    address.city,
    address.state,
    address.postalCode
  ]
    .map(part => part?.trim())
    .filter(Boolean)
    .join(", ");

  return line || undefined;
};
